export default __webpack_public_path__ + "static/media/coinbase.ff1bcce1.svg";